import React from "react";

import { Form } from "semantic-ui-react";

import DateComponent from "@common/components/shared/forms/DateComponent";
import TimeComponent from "@common/components/shared/forms/TimeComponent";

/**
 * DateAndTimeGroup renders a grouped date and time component with validation.
 *
 * @typedef {object} InputProps
 * @property {Function} control - Function to control the date field for form
 * @property {Object} [errorsDate=null] - Object containing validation error for date.
 * @property {Object} [errorsTime=null] - Object containing validation error for time.
 * @property {string} [dateName='date'] - Name of the date field.
 * @property {string} [timeName='time'] - Name of the time field.
 * @property {string} [dateLabel='Date'] - Label of the date field.
 * @property {string} [timeLabel='Time'] - Label of the time field.
 * @property {string} [dateFormat='DD MM YYYY'] - The format of the date.
 * @property {string} [timeFormat='HH:mm'] - The format of the time.
 * @property {string} [maxDate=null] - The maximum date possible to be selected.
 *
 * @component
 * @param {InputProps} props - The component props.
 * @returns {JSX.Element} The rendered date and time fields with validation.
 */

export default function DateAndTimeGroup({
  control,
  dateName = "date",
  timeName = "time",
  dateLabel = "Date",
  timeLabel = "Time",
  dateFormat = "DD MM YYYY",
  timeFormat = "HH:mm",
  errorsDate = null,
  errorsTime = null,
  maxDate = null,
}) {
  return (
    <Form.Group className="space-between mb-1">
      <DateComponent
        control={control}
        name={dateName}
        label={dateLabel}
        labelAbove={true}
        dateFormat={dateFormat}
        maxDate={maxDate}
        fieldStyle={"w-50"}
        error={errorsDate}
      />

      <TimeComponent
        control={control}
        name={timeName}
        dateName={dateName}
        label={timeLabel}
        labelAbove={true}
        timeFormat={timeFormat}
        fieldStyle={"w-40"}
        error={errorsTime}
      />
    </Form.Group>
  );
}
